// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Rating';



// WEBPACK FOOTER //
// ./components/Rating/index.js